import showNotification from './notification';

const successNotification = (message = '') =>
  showNotification({ type: 'success', message });

export default successNotification;
